import React from 'react';
import { toTextQuestionAnswer } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { LongText } from './LongText';
import { ViewUrlText } from './view/ViewUrlText';
export var UrlText = function UrlText(questionProps) {
  var questionStore = questionProps.questionStore,
    displayMode = questionProps.displayMode,
    fieldId = questionProps.id;
  return displayMode === DisplayMode.Edit ? /*#__PURE__*/React.createElement(LongText, questionProps) : /*#__PURE__*/React.createElement(ViewUrlText, {
    id: fieldId,
    value: toTextQuestionAnswer(questionStore.currentAnswer),
    displayMode: displayMode
  });
};